export const TOKEN_KEY = 'blablacolis_token';
export const REFRESH_TOKEN_KEY = 'blablacolis_refresh_token';
const ACTIVITY_KEY = 'blablacolis_last_activity';
const DEADLINE_KEY = 'blablacolis_session_deadline';
const IDENTITY_KEY = 'blablacolis_tab_session_id';
export const SESSION_EXPIRED_EVENT = 'blablacolis-session-expired';
export const IDLE_TIMEOUT_MS = 30 * 60 * 1000;
export const WARNING_MS = 2 * 60 * 1000;
let sessionGeneration = 0;

export const removeLegacyTokens = () => {
  localStorage.removeItem(TOKEN_KEY);
  localStorage.removeItem(REFRESH_TOKEN_KEY);
};
export const clearSessionTokens = () => {
  [TOKEN_KEY, REFRESH_TOKEN_KEY, ACTIVITY_KEY, DEADLINE_KEY, IDENTITY_KEY].forEach(key => sessionStorage.removeItem(key));
  removeLegacyTokens();
};
export const getAccessToken = () => sessionStorage.getItem(TOKEN_KEY);
export const getRefreshToken = () => sessionStorage.getItem(REFRESH_TOKEN_KEY);
export const getSessionIdentity = () => sessionStorage.getItem(IDENTITY_KEY);
export const getSessionRemaining = () => {
  const activity = Number(sessionStorage.getItem(ACTIVITY_KEY));
  const deadline = Number(sessionStorage.getItem(DEADLINE_KEY));
  if (!activity || !deadline) return 0;
  return Math.min(activity + IDLE_TIMEOUT_MS, deadline) - Date.now();
};
export const expireSession = () => {
  clearSessionTokens();
  window.dispatchEvent(new Event(SESSION_EXPIRED_EVENT));
};
export const assertActiveSession = () => {
  if (getAccessToken() && getSessionRemaining() <= 0) {
    expireSession();
    throw new Error('Session expirée, veuillez vous reconnecter');
  }
};
export const recordUserActivity = () => {
  if (!getAccessToken()) return;
  assertActiveSession();
  sessionStorage.setItem(ACTIVITY_KEY, String(Date.now()));
};
export const storeSessionTokens = (accessToken, refreshToken, newSession = false) => {
  let serverDeadline;
  try {
    const payload = JSON.parse(atob(accessToken.split('.')[1].replace(/-/g, '+').replace(/_/g, '/')));
    serverDeadline = Number(payload.session_exp) * 1000;
  } catch { /* demo/testing tokens use a bounded local deadline */ }
  if (newSession) clearSessionTokens();
  if (!getSessionIdentity()) {
    // Local race guard only, not a credential or a server authorization token.
    sessionGeneration += 1;
    sessionStorage.setItem(IDENTITY_KEY, `${Date.now()}-${sessionGeneration}-${Math.random()}`);
  }
  const existingDeadline = Number(sessionStorage.getItem(DEADLINE_KEY));
  const deadline = Math.min(serverDeadline || Date.now() + 12 * 60 * 60 * 1000, existingDeadline || Infinity);
  if (accessToken) sessionStorage.setItem(TOKEN_KEY, accessToken);
  if (refreshToken) sessionStorage.setItem(REFRESH_TOKEN_KEY, refreshToken);
  sessionStorage.setItem(DEADLINE_KEY, String(deadline));
  if (!sessionStorage.getItem(ACTIVITY_KEY)) sessionStorage.setItem(ACTIVITY_KEY, String(Date.now()));
  removeLegacyTokens();
};